import type {
  EmployeeEdge,
  GetProfilesQueryResult,
  ProfileFragment,
  ResidentEdge,
} from "@/graphql";
import { Profile_Type } from "@/graphql/generated-types";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: ProfileFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: `${item.name?.trim()} ${item.surname?.trim()}`.trim(),
    imageURL: item.image?.source,
    blurhash: item.image?.blurhash,
  };
};

const toOption = (item: ProfileFragment): IOption => {
  return {
    value: item.id,
    title: item.name || "",
  };
};

const fromEmployeeToProfile = (employeeEdges?: EmployeeEdge[] | null) => {
  if (!employeeEdges) {
    return [];
  }

  const results: ProfileFragment[] = [];
  employeeEdges.forEach((item) => {
    if (item.node.__typename === "Employee") {
      results.push({
        id: item.node.id,
        name: item.node.name || "",
        surname: item.node.surname || "",
        type: item.node.type,
        departments: item.node.departments,
        image: item.node.image,
      });
    }
  });

  return results;
};

const fromResidentToProfile = (residents?: ResidentEdge[] | null) => {
  if (!residents) {
    return [];
  }

  const results: ProfileFragment[] = [];
  residents.forEach((item) => {
    if (item.node.__typename === "Resident") {
      results.push({
        id: item.node.id,
        name: item.node.name || "",
        surname: item.node.surname || "",
        type: Profile_Type.Resident,
        departments: item.node.departments,
        image: item.node.image,
      });
    }
  });

  return results;
};

const toProfileFragment = (
  result: GetProfilesQueryResult,
): ProfileFragment[] => {
  const { employees, residents } = result;

  return [
    ...fromEmployeeToProfile(employees?.edges),
    ...fromResidentToProfile(residents?.edges),
  ];
};

export default {
  toMultiSelectItem,
  toOption,
  toProfileFragment,
};
